const TOAST_NAME = "Toast",
  TOAST_CONTEXT = "Toast";
export { TOAST_CONTEXT, TOAST_NAME };
//# sourceMappingURL=constants.mjs.map
